import React from 'react';
import SubHeader from './subHeader';
import AuthService from '../utils/authService';
import RegisterDashboardForm from './registerDashboardForm';
import SitelogDashboardForm from './sitelogDashboardForm';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const WEEKS = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53];

class HomePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            week: 0,
            activeTab: 'register'
        };
    }

    onWeekChange = (week) => {
        this.setState({ week });
    }

    render() {
        const roles = AuthService.getRoles();
        const hasRegister = roles.indexOf("register") > -1;
        const hasSitelog = roles.indexOf("sitelog") > -1;
        const { week, activeTab } = this.state;

        const defaultTab = hasRegister ? 'register' : 'sitelog';
        const currentTab = activeTab || defaultTab;

        return (
            <div>

                <SubHeader title={'Dashboard'} />

                <div className="dash-sticky-bar">
                    <div className="dash-sticky-week">
                        <div style={{width: 160}}>
                            <DropDownList
                                placeholder="Week"
                                name="week"
                                data={WEEKS}
                                onChange={(e) => this.onWeekChange(e.target.value)}
                                value={week}
                            />
                        </div>
                        <span className="dash-week-label">Viewing Week {week}</span>
                    </div>
                    <div className="dash-sticky-tabs">
                        {hasRegister && (
                            <button
                                className={`dash-tab-btn${currentTab === 'register' ? ' active' : ''}`}
                                onClick={() => this.setState({ activeTab: 'register' }, () => window.dispatchEvent(new Event('resize')))}
                            >
                                <i className="mdi mdi-login"></i> Register Statistics
                            </button>
                        )}
                        {hasSitelog && (
                            <button
                                className={`dash-tab-btn${currentTab === 'sitelog' ? ' active' : ''}`}
                                onClick={() => this.setState({ activeTab: 'sitelog' }, () => window.dispatchEvent(new Event('resize')))}
                            >
                                <i className="mdi mdi-train"></i> Worksite Statistics
                            </button>
                        )}
                    </div>
                </div>

                <div className="container-fluid" style={{paddingTop: 12}}>

                    {hasRegister && (
                        <div style={{display: currentTab === 'register' ? 'block' : 'none'}}>
                            <RegisterDashboardForm week={week} onWeekLoaded={this.onWeekChange} />
                        </div>
                    )}

                    {hasSitelog && (
                        <div style={{display: currentTab === 'sitelog' ? 'block' : 'none'}}>
                            <SitelogDashboardForm />
                        </div>
                    )}

                </div>

            </div>
        )
    }
}

export default HomePage;
